import { Navigate } from "react-router-dom";
import { Page403 } from "../../../root/general/modules/pages/Page403";

type Props = {
  children: JSX.Element;
  user: { role: string } | undefined;
  allowedRoles?: string[];
};

export const ProtectedRoute = ({
  user,
  allowedRoles,
  children,
}: Props): JSX.Element => {
  if (user === undefined || user === null || Object.keys(user).length === 0) {
    return <Navigate to="/auth/login" replace />;
  }

  if (
    allowedRoles !== undefined &&
    allowedRoles !== null &&
    !allowedRoles.includes(user.role)
  ) {
    return <Page403></Page403>;
  }

  return <>{children}</>;
};
